import {
    ADMIN_UPDATE_STATIC_START,
    ADMIN_UPDATE_STATIC_SUCCESS,
    ADMIN_UPDATE_STATIC_ERROR
} from '../../constants';
// Redirection
import history from '../../core/history';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { updateStaticPage as mutation, getEditStaticPage as query } from '../../lib/graphql';

export const updateStaticPageAction = (values) => {
    return async (dispatch, getState, { client }) => {
        try {

            dispatch({ type: ADMIN_UPDATE_STATIC_START });
            const { data } = await client.mutate({
                mutation,
                variables: {
                    id: values.id,
                    content: values.content,
                    content_en: values.content_en,
                    content_fr: values.content_fr,
                    content_it: values.content_it,
                    content_pt: values.content_pt,
                    metaTitle: values.metaTitle,
                    metaTitle_en: values.metaTitle_en,
                    metaTitle_fr: values.metaTitle_fr,
                    metaTitle_it: values.metaTitle_it,
                    metaTitle_pt: values.metaTitle_pt,
                    metaDescription: values.metaDescription,
                    metaDescription_en: values.metaDescription_en,
                    metaDescription_fr: values.metaDescription_fr,
                    metaDescription_it: values.metaDescription_it,
                    metaDescription_pt: values.metaDescription_pt,
                },
                refetchQueries: [{ query, variables: { id: values.id } }]
            });

            if (data?.updateStaticPage?.status === "success") {
                showToaster({ messageId: 'updateStaticPageSuccess', toasterType: 'success' })
                history.push('/siteadmin/staticpage/management');
                dispatch({ type: ADMIN_UPDATE_STATIC_SUCCESS });
            }
            else {
                showToaster({ messageId: 'updateStaticPageFailed', toasterType: 'error' })
                dispatch({ type: ADMIN_UPDATE_STATIC_ERROR });
            }

        } catch (error) {
            console.log(error);
            showToaster({ messageId: 'updateStaticPageStatus', toasterType: 'error' })
            dispatch({ type: ADMIN_UPDATE_STATIC_ERROR });
            return false;
        }
        return true;
    };
}